import React from "react";
import { getSEOData } from "../../../global/utils/constants/seoConfig";
import SEO from "../../../global/components/SEO/SEO";
import AboutContent from "../Components/AboutContent";

const About = () => {
  const seoData = getSEOData("/company");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <div>
        <AboutContent />
      </div>
    </>
  );
};

export default About;
